import { getProjects } from '../services/projectsService';

/**
 * Proyectos y operaciones activas (configuración) para planeamiento (plantillas cíclicas, cíclicos, salidas).
 * `id` en string para coincidir con valores guardados en localStorage.
 */
export async function fetchProjectsForPlaneamiento() {
  try {
    const res = await getProjects({ active_only: true, type: 'all' });
    if (!res?.success || !Array.isArray(res.data)) return [];
    return res.data.map((p) => ({
      id: String(p.id),
      name: p.name,
      code: p.code,
      type: p.type,
    }));
  } catch {
    return [];
  }
}

export function nombreProyectoDesdeLista(proyectoId, lista) {
  if (proyectoId == null || proyectoId === '') return '—';
  const id = String(proyectoId);
  const row = (lista || []).find((p) => String(p.id) === id);
  return row?.name || id;
}
